<div class="login-card trusted-card">

  @if (trusted.stage === 'ask') {
  <div class="trusted-icon" aria-hidden="true">
    <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#edc99e" stroke-width="1.6"
      stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 22s8-3.6 8-9V5.4L12 2 4 5.4V13c0 5.4 8 9 8 9z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  </div>

  @if (trusted.primaryDeviceId) {
  <span class="trusted-title">Make this a trusted device</span>
  <span class="trusted-subtitle">
    Link this browser to your account, or continue with a limited session.
  </span>
  } @else {
  <span class="trusted-title">No primary device linked yet</span>
  <span class="trusted-subtitle">
    We recommend using our mobile app as your primary device, so chats stay end-to-end encrypted and
    sessions last longer. You can continue with a limited session on this device for now.
  </span>
  }

  <div class="trusted-benefits">
    <div class="benefit-row">
      <span class="benefit-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 6v6l4 2" />
        </svg>
      </span>
      <div class="benefit-text">
        <span class="benefit-title">Stay signed in longer</span>
        <span class="benefit-desc">Extended sessions, without frequent re-logins</span>
      </div>
    </div>

    <div class="benefit-row">
      <span class="benefit-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      </span>
      <div class="benefit-text">
        <span class="benefit-title">Full access to chat &amp; social</span>
        <span class="benefit-desc">Untrusted sessions don't include chat on this device</span>
      </div>
    </div>
  </div>

  <div class="trusted-bottom">
  @if (trusted.primaryDeviceId && trusted.primaryDeviceName) {
  <div class="primary-device-chip">
    <span class="chip-phone-icon">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
        stroke-linecap="round" stroke-linejoin="round">
        <rect x="5" y="2" width="14" height="20" rx="2" />
        <path d="M12 18h.01" />
      </svg>
    </span>
    <div class="chip-text">
      <span class="chip-label">Primary device</span>
      <span class="chip-name">{{ trusted.primaryDeviceName }}</span>
      @if (trusted.primaryDeviceLocation) {
      <span class="chip-location">{{ trusted.primaryDeviceLocation }}</span>
      }
    </div>
  </div>
  }

  @if (trusted.error) {
  <small class="error-text" style="text-align: center">{{ trusted.error }}</small>
  }

  <div class="trusted-actions">
    @if (trusted.primaryDeviceId && showTrustButton) {
    <button class="verify-btn" [disabled]="trusted.loadingAction !== null" (click)="trustRequested.emit()">
      @if (trusted.loadingAction === 'trust') {
      <span class="spinner" role="status" aria-label="Loading"></span>
      } @else { Trust this device }
    </button>
    }

    <button class="untrusted-btn" [disabled]="trusted.loadingAction !== null" (click)="untrustedRequested.emit()">
      @if (trusted.loadingAction === 'untrusted') {
      <span class="spinner spinner-light" role="status" aria-label="Loading"></span>
      } @else { Continue untrusted }
    </button>
  </div>

  @if (trusted.primaryDeviceId) {
  <span class="trusted-note">
    You can trust up to 2 web devices. Manage them anytime from your primary device.
  </span>
  }
  </div>
  }

  @else if (trusted.stage === 'selectDevice') {
  <div class="code-stage">
  <div class="trusted-icon" aria-hidden="true">
    <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#edc99e" stroke-width="1.6"
      stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="11" width="18" height="10" rx="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  </div>

  <span class="trusted-title">Choose a device to log out</span>
  <span class="trusted-subtitle">
    You already have 2 trusted web devices. Pick one to log out so this browser can take its place.
  </span>

  <div class="device-select-list">
    @for (device of trusted.webDevices; track device.deviceId) {
    <div class="device-select-item" [class.selected]="trusted.selectedRemoveDeviceId === device.deviceId"
      (click)="deviceSelected.emit(device.deviceId)">
      <span class="device-radio"></span>
      <div class="chip-text">
        <span class="chip-name">{{ device.deviceName }}</span>
        @if (device.location) {
        <span class="chip-location">{{ device.location }}</span>
        }
      </div>
    </div>
    }
  </div>

  @if (trusted.error) {
  <small class="error-text" style="text-align: center">{{ trusted.error }}</small>
  }

  <button class="verify-btn" [disabled]="trusted.loadingAction !== null || !trusted.selectedRemoveDeviceId"
    (click)="removalConfirmed.emit()">
    @if (trusted.loadingAction === 'trust') {
    <span class="spinner" role="status" aria-label="Loading"></span>
    } @else { Log out selected device &amp; continue }
  </button>

  <div class="resend-text">
    <span class="back" (click)="selectionCancelled.emit()">Back</span>
  </div>
  </div>
  }

  @else {
  <div class="code-stage">
  <div class="trusted-icon phone-waiting" aria-hidden="true">
    <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#edc99e" stroke-width="1.6"
      stroke-linecap="round" stroke-linejoin="round">
      <rect x="5" y="2" width="14" height="20" rx="2" />
      <path d="M12 18h.01" />
    </svg>
  </div>

  <span class="trusted-title">Approve on your phone</span>
  <span class="trusted-subtitle">
    We sent a notification with a 6-digit code to
    <strong class="highlight">{{ trusted.primaryDeviceName }}</strong>. Enter that code below to trust this
    device.
  </span>

  <div class="form-group code-group">


    <div class="code-cells" [class.shake]="shake">
      @for (i of cells; track i) {
      <input
        #codeCell
        type="text"
        inputmode="numeric"
        autocomplete="one-time-code"
        maxlength="6"
        [value]="digits[i]"
        [class.filled]="digits[i]"
        [class.cell-error]="!!trusted.error"
        class="code-cell"
        [attr.aria-label]="'Code digit ' + (i + 1)"
        (input)="onCodeInput(i, $event)"
        (keydown)="onCodeKeyDown(i, $event)"
        (paste)="onCodePaste($event)"
        (focus)="onCodeFocus($event)" />
      }
    </div>

    @if (trusted.error) {
    <small class="error-text">{{ trusted.error }}</small>
    }
  </div>

  <button class="verify-btn" [disabled]="trusted.loadingAction !== null || !isCodeComplete"
    (click)="codeVerified.emit()">
    @if (trusted.loadingAction === 'verify') {
    <span class="spinner" role="status" aria-label="Loading"></span>
    } @else { Verify &amp; trust this device }
  </button>

  <div class="resend-text">
    Didn't get it?
    <span class="resend-link" (click)="codeResent.emit()">Resend notification</span>
  </div>

  <div class="resend-text">
    <span class="back" (click)="codeCancelled.emit()">Back</span>
  </div>
  </div>
  }
</div>
